import React, {Component} from 'react';
import assets from "../../util/assets"
export default class ExitSessionModal extends Component {

    render() {
        return (
            <div id="end-broadcast-session" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                {
                                    this.props.hideCrossButton !== true &&
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={this.props.toggleEndSessionModal}>
                                    <img alt={"close-icon-sangam"} src={assets.broadcast.cross}/></button>
                                }
                            </div>
                            <div className="modal-body">
                                {this.props.broadcaster && this.props.broadcaster !== null ? <div>
                                    <div className="followers-img-wrapper">
                                        <div className="followers-img">
                                            <img src={this.props.broadcaster.profile_pic}  width={"100%"} alt="followers"/>
                                        </div>
                                    </div>
                                    <h5>{this.props.broadcaster.username}</h5>
                                    <p>{this.props.broadcaster.broadcast[0].session_title}</p>
                                    <p><strong>{this.props.broadcasterLeftSession ? (this.props.otherRequestAccepted ? "Broadcaster has left the session and is busy in private session": "Broadcaster has left the session")
                                        :
                                        "Are you sure you want to leave this session?"}</strong></p>
                                </div>
                                :
                                    this.props.viewerLeftSession ?
                                    <p><strong>Viewer Left the session.</strong></p>
                                        :
                                        <p><strong>You have selected to end the broadcast.<br/>What would you like to
                                            do?</strong></p>
                                }

                            </div>
                            <div className="modal-footer">
                                {this.props.broadcasterLeftSession !== true && this.props.viewerLeftSession !== true && <button type="button" className="btn btn-outline-primary"
                                        onClick={this.props.toggleEndSessionModal}>Return to session
                                </button>}
                                <button type="button" className="btn btn-link" data-dismiss="modal"
                                        onClick={this.props.disconnectOTSession}>
                                    {this.props.broadcaster && this.props.broadcaster !== null ? "Leave session" : "Exit session"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}